function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// import shave from "shave";
import { trackAddToCart, checkCartItemDetails } from "../../components/stoked";
import { addToBag, updateKlarna } from "../../shop/connect";
import { update, updateCartNewAdded } from "../../shop/render";
import { stokpress, stokpressViewPort } from "../../util/helper";
var preScrollHeight = 0;
var preScrollOffset = 0;
var addToBagListener = function addToBagListener() {
  // Systems page - Add to bag
  if ($("body.shop-the-system").length > 0) {
    // quickshop
    $(document).find(".js-quickshop-add").off("click").on("click", function (e) {
      e.preventDefault();
      var form = $(this).parents(".js-quickadd-form").find("form");
      if (form) {
        var size = $($(this).data("target")).find("input.js-esc-product-item:checked");
        form.find('input[name="esc_product_item"]').val(size.val());
        form.find('input[name="esc_post"]').val($(this).data("post"));
        form.find('input[name="esc_item_id"]').val($(this).attr("id"));
        form.trigger("submit");
      }
    });
  }
  $(document).on("click", ".js-addToCart input[name='esc_product_item']", function (e) {
    if (e.currentTarget) {
      var $this = $(e.currentTarget);
      var button = $this.parents(".js-addToCart").find("button[type='submit']");
      button.removeClass(button.data("added") || "");
      button.find(".js-cartButtonLabel").text(button.find(".js-cartButtonLabel").data("default") || "");
    }
  });

  // Has size selected
  $('input[name="esc_product_item"], select[name="esc_product_item"]').off("change").on("change", function (e) {
    e.preventDefault();
    var cartForm = ".js-selectProductSingle";
    var cartFormInline = ".js-selectProduct";
    updateButtonText("text", $(cartForm).find("button"));
    updateButtonText("text", $(cartFormInline).find("button"));
  });
  $("input.js-esc-product-item").off("change").on("change", function (e) {
    updateButtonText("text", $(this).parents(".system-bundle-item-options").find("button"));
  });
  $(document).on("submit", ".js-addToCart", function (e) {
    e.preventDefault();
    if (e.currentTarget) {
      var $this = $(e.currentTarget);
      var formInputs = $this.serializeArray().reduce(function (acc, input) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, input.name, input.value));
      }, {});
      var buttonEl = $this.find("button");
      if (buttonEl.length === 0) {
        var item_id = $this.find('input[name="esc_item_id"]').val();
        buttonEl = $("#" + item_id);
      }
      if (!formInputs.esc_product_item) {
        updateButtonText("error", buttonEl);
        if (buttonEl.length && (buttonEl.data().scollto !== false || typeof buttonEl.data().scollto === "undefined")) {
          var isMobile = stokpress.isMobile() || stokpressViewPort.documentWidth().width < 720;
          var navHeight = $("nav").height() + parseInt($("nav").css("padding-top"));
          var scrollToPos = 0;

          // Scroll to sizes
          if (isMobile) {
            scrollToPos = Math.abs(document.documentElement.clientHeight - buttonEl.offset().top - (buttonEl.height() + navHeight) - 65);
          }

          // Scroll to size error if current page is single page
          if ($("body.single").length) {
            $("html, body").animate({
              scrollTop: scrollToPos
            }, 1000);
          }
        }
        return;
      }
      buttonEl.addClass("is-loading").prop("disabled", true);
      var showCartOverlay = $("#js-checkout").length === 0;
      preScrollHeight = $(document).height();
      preScrollOffset = $(document).scrollTop();
      addToBag(formInputs.esc_product_item).then(function () {
        var cartContainer = $(".js-cart-overlay");
        var body = $("body");
        if (window.CentraCheckout) {
          updateKlarna();
        }
        if (showCartOverlay) {
          cartContainer.addClass("is-open");
          body.addClass("cart-overlay");
        } else {
          // Checkout add ons - this is to fix Safari scrollTo top when an element is added in the cart
          var postScrollOffset = $(document).scrollTop();
          if (preScrollOffset && postScrollOffset && preScrollOffset === postScrollOffset) {
            var postScrollHeight = $(document).height();
            var deltaHeight = postScrollHeight - preScrollHeight;
            $("html, body").animate({
              scrollTop: postScrollOffset + deltaHeight
            }, 1);
            console.log("Scrolling by", deltaHeight, "px");
          }
        }
        setTimeout(function () {
          if (showCartOverlay) {
            cartContainer.removeClass("is-open");
            body.removeClass("cart-overlay");
          }
          update();
        }, 2500);
        buttonEl.removeClass("is-loading").prop("disabled", false);
        var buttonLabel = buttonEl.find(".js-cartButtonLabel");
        if (buttonLabel.length && buttonLabel.data("added")) {
          buttonLabel.text(buttonLabel.data("added"));
          buttonEl.addClass(buttonEl.data("added"));
        }
        updateButtonText("success", buttonEl);
        var _checkCartItemDetails = checkCartItemDetails(formInputs.esc_product_item),
          line = _checkCartItemDetails.line,
          isLatestItemInSelection = _checkCartItemDetails.isLatestItemInSelection;
        $.event.trigger("stoked-add-to-cart", [line, 1, isLatestItemInSelection, trackAddToCart]);
        updateCartNewAdded(formInputs.esc_product_item);
      }).catch(function () {
        $this.removeClass("is-success");
        $this.addClass("is-error");
      });
    }
  });
};
var updateButtonText = function updateButtonText(dataAttr, buttonEl) {
  if (!buttonEl.length) {
    return;
  }
  var textVal = buttonEl.data(dataAttr);
  var buttonTextEl = buttonEl.find(".js-button-text");
  if (buttonTextEl) {
    buttonTextEl.text(textVal);
  }
  var productWrap = $(buttonEl.data("target"));
  if (productWrap.length === 0) return;
  if (dataAttr === "success") {
    buttonEl.prop("disabled", true);
    buttonEl.find(".js-success-icon").removeClass("d-none");
    productWrap.addClass(buttonEl.data("success-class"));
  } else {
    buttonEl.prop("disabled", false);
    buttonEl.find(".js-success-icon").addClass("d-none");
    productWrap.removeClass(buttonEl.data("success-class"));
  }
};
var scrolledPosition = function scrolledPosition(item) {
  var scrollPos = 0;
  var delay = 200;
  if ($("#js-checkout").length) {
    var itemSelector = $("#js-checkoutPageItems .js-cartItem[data-item=\"".concat(item, "\"]")).length ? $("#js-checkoutPageItems .js-cartItem[data-item=\"".concat(item, "\"]")) : $("#js-checkoutPageItems .js-cartItem");
    scrollPos = itemSelector.last().offset().top - window.innerHeight / 2;
    delay = 500;
  }
  $("html,body").animate({
    scrollTop: scrollPos
  }, 200);
};
export default addToBagListener;


// WEBPACK FOOTER //
// ./scripts/partials/list/productItem.js